import React from 'react'
import 'react-animated-slider/build/horizontal.css'
import '../assets/css/slider-animations.css'
import Helmet from 'react-helmet'
import BannerHome from '../components/BannerHome'
import Banner from '../components/Banner'
import pic11 from '../assets/images/library-staircase.jpg'
import pic12 from '../assets/images/young-boys-soccer.jpg'
import pic13 from '../assets/images/andy-burnham_profile.jpg'
import pic14 from '../assets/images/betway-banner.jpg'


class HomeIndex extends React.Component {
    render() {
        const siteTitle = this.props.data.site.siteMetadata.title
        const siteDescription = this.props.data.site.siteMetadata.description

        return (
            <div>
                <Helmet>
                    <title>{siteTitle}</title>
                    <meta name="description" content={siteDescription} />
                </Helmet>

                <BannerHome />

                <div id="main">
                    <section id="two" className="spotlights">
                        <section>
                            <div to="/generic" className="image">
                                <img alt="" src={pic11} />
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <header className="major">
                                        <h3>Failing Education</h3>
                                    </header>
                                    <p>A recent quote from Stella Creasy, Labour MP expresses concerns that the nation’s football team could well be 
                                    <a href="https://www.businessinsider.com/england-national-football-team-uk-great-britain-2018-6/" target="_blank" rel="follow"> underperforming 
                                    due to a glut of players</a> coming from a private education 
                                    background, raising concerns that talented players who come through the state school system are likely to be missed.</p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <div className="image">
                                <img alt="" src={pic12}/>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <header className="major">
                                        <h3>Pivately educated footballers</h3>
                                    </header>
                                    <p>13% of England’s national team were privately educated – a figure which represents twice that of 
                                    those who attend private school nationally. This suggests that there is an increasing problem of a narrowed focus on talent, with 
                                    comprehensive schools being overlooked as a source of skilled players.</p>
                                    <p>This statement, however, has been dismissed as irrelevant by Mr Redwood, Wokingham’s MP, who supports the idea of developing 
                                    more grammar schools specifically because of 
                                    their ability to select young talent at an earlier age allowing them more time to hone their skills.</p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <a className="image"><img alt="" src={pic13} /></a>                      
                            <div className="content">
                                <div className="inner">
                                    <header className="major">
                                        <h3>The debate criticism</h3>
                                    </header>
                                    <p>Andy Burnham, our former shadow home secretary, 
                                    who expressed his opposition to the idea of giving more schools the opportunity to select pupils. 
                                    His opinion is that sports aren’t really about life as a whole, and he cites the idea 
                                    that labelling any child at the age of 11 as second rate is wrong.</p>
                                </div>
                            </div>
                        </section>
                    </section>

                    <Banner />

                    <section id="three">
                        <div className="inner">
                            <header className="major">
                                <h2>PPF’s Educational Reach</h2>
                            </header>

                            <div className="image">
                                <img className="betway-img" alt="betway-banner" src={pic14} />
                            </div>
                            <br/>
                            <br/>
                            <p>The Chairman of the PPF also released a statement welcoming Betway to its partnership, pointing out the 
                            importance of athlete education and his delight in seeing a 
                            betting company offering its support to his company’s most vital work.
                            Thanks to the sportsbook’s support, the PPF will be able to expand their educational reach, working productively 
                            in collaboration with the betting industry to enhance the reputation 
                            of the UK as a home of fair play, integrity and sporting excellence.</p>
                            <p>It is hoped now that this most recent pairing of a sporting organisation and a sports betting company will 
                            lead to further projects of a similar nature to boost the educational profile of the UK’s premier athletes and the rising stars and homegrown 
                            talent of the sporting community right across the nation and across a range of sporting sectors. </p>
                            <p>It is hoped now that this most recent pairing of a sporting organisation and a sports betting company will 
                            lead to further projects of a similar nature to boost the educational profile of the UK’s premier athletes and the rising stars and 
                            homegrown talent of the sporting community right across the nation and across a range of sporting sectors. </p>
                        </div>
                    </section>
                </div>
            </div>
        )
    }
}

export default HomeIndex

export const pageQuery = graphql`
    query PageQuery {
        site {
            siteMetadata {
                title
                description
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/pages/index.js